import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress benign ResizeObserver "loop completed with undelivered notifications" (browser/lib quirk)
const prevOnError = window.onerror;
window.onerror = function (message, ...rest) {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) return true;
  return typeof prevOnError === 'function' ? prevOnError(message, ...rest) : false;
};
import './global-styles/base-style.scss';
import './global-styles/antd-custom.scss';
import './global-styles/light-theme.scss';
import './global-styles/admin.scss';
import './global-styles/admin-lightTheme.scss';
import './global-styles/equipments-history-modal-overrides.css';
import './global-styles/antd-select-dropdown-portal.scss';

import 'ag-grid-enterprise';
import { LicenseManager } from '@ag-grid-enterprise/core';
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_ENTERPRISE_LICENSE);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
